export const MEDIA_CATEGORIES = {
	YOUTUBE: 'YouTube',
	SPOTIFY: 'Spotify'
};

export const MEDIA_STARTED_EVENT = 'mediaStarted';
export const MEDIA_PROCESS_EVENT = 'mediaProcess';
export const MEDIA_FINISHED_EVENT = 'mediaFinished';

export const MEDIA_PERCENT_THRESHOLDS = [90, 75, 50, 25];

export default {
	data() {
		return {
			mediaPercentThresholds: [...MEDIA_PERCENT_THRESHOLDS]
		};
	},
	methods: {
		resetMediaPercentThresholds() {
			this.mediaPercentThresholds = [...MEDIA_PERCENT_THRESHOLDS];
		},
		sendMediaStarted(mediaName, mediaCategory) {
			this.sendMediaGtm(MEDIA_STARTED_EVENT, mediaName, mediaCategory, 0);
		},
		sendMediaProcess(mediaName, mediaCategory, percent) {
			const threshold = this.mediaPercentThresholds.find((value) => percent >= value);
			if (!threshold) {
				return;
			}
			this.mediaPercentThresholds = this.mediaPercentThresholds.filter((value) => value > threshold);
			this.sendMediaGtm(MEDIA_PROCESS_EVENT, mediaName, mediaCategory, threshold);
		},
		sendMediaFinished(mediaName, mediaCategory) {
			this.sendMediaGtm(MEDIA_FINISHED_EVENT, mediaName, mediaCategory, 100);
			this.resetMediaPercentThresholds();
		},
		sendMediaGtm(event, mediaName, mediaCategory, mediaPercent) {
			this.$gtm.trackEvent({
				event,
				mediaName,
				mediaCategory,
				mediaPercent
			});
		}
	}
};
